import { inject, type InjectionKey, provide, ref } from 'vue';

type Refuse = (message: string) => void;

const refusalKey: InjectionKey<Refuse> = Symbol('refusal');

export function provideRefusal() {
  const refusal = ref('');
  const refuse: Refuse = (message) => (refusal.value = message);
  provide(refusalKey, refuse);
  return { refusal, refuse };
}

export const useRefuse = () => inject(refusalKey, () => {});
